
import { StufoeEvent, StufoeEventCategory } from '../../../scripts/api/models/events';
import { ActionContext } from 'vuex';

///
// State

export type State = {
    topLevelCategories: null | StufoeEventCategory[],

    showPastEvents: boolean,
}

///
// Mutations

export enum MutationTypes {
    LOAD_EVENTS = 'LOAD_EVENTS',
    SET_VIEW = 'SET_VIEW',
}

type MutationsWithParameter<S = State> = {
    [MutationTypes.LOAD_EVENTS](state: S, payload: { events: StufoeEvent[], categories: StufoeEventCategory[] }): void
    [MutationTypes.SET_VIEW](state: S, payload: { showPastEvents: boolean }): void
};
export type Mutations<S = State> = MutationsWithParameter;

///
// Actions

export type AugmentedActionContext = {
    commit<K extends keyof MutationsWithParameter>(
        key: K,
        payload: Parameters<MutationsWithParameter[K]>[1]
    ): ReturnType<MutationsWithParameter[K]>
} & Omit<ActionContext<State, State>, 'commit'>

export interface Actions {
    setView ({ commit }: AugmentedActionContext, payload: { showPastEvents: boolean }): void
    loadEvents ({ commit }: AugmentedActionContext, payload: { events: StufoeEvent[], categories: StufoeEventCategory[] }): void
}

///
// Getters

export interface Getters {
    topLevelCategories(state: State): StufoeEventCategory[];
    showPastEvents(state: State): boolean;
}
